module.exports = __webpack_public_path__ + "img/cadastro-checklist.82d9ab48.jpg";